import React from 'react'
import {
  Container,
  Header,
  List
} from 'semantic-ui-react'

const Mistakes = () => (
  <Container text style={{ marginTop: '7em' }}>
    <Header as='h1'>Minor mistakes in CS2013</Header>
    <p>
      When converting the <a href="https://www.acm.org/binaries/content/assets/education/cs2013_web_final.pdf">CS2013 PDF document</a> into the JSON file driving this web site,
      we noticed and corrected the following minor mistakes (inconsistencies) in the PDF:
    </p>
    <List bulleted>
      <List.Item>"IAS/Threats and Attacks" Includes Electives: N (table on page 98)</List.Item>
      <List.Item>"IAS/Cryptography" Includes Electives: N (table on page 98)</List.Item>
      <List.Item>"IS/Fundamental Issues" Includes Electives: Y (table on page 121)</List.Item>
      <List.Item>"SE. Software Engineering" has 21 core-tier2 hours (header on page 175)</List.Item>
      <List.Item>"SE/Software Evolution" Includes Electives: Y (table on page 175)</List.Item>
    </List>
  </Container>
)

export default Mistakes